<template>
  <div>
    <!-- <load-profile /> -->
    <b-tabs
      v-model="tabIndex"
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
    >
      <!-- v-model="tabIndex" -->
      <!-- general tab -->
      <!-- <b-tab>
        <template #title>
          <feather-icon icon="HelpCircleIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t("breadcrumb.question")
          }}</span>
        </template>
        <div id="question-search"></div>
        <question-list />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="MessageCircleIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t("breadcrumb.frequently_asked_questions")
          }}</span>
        </template>
        <div id="faq-search"></div>
        <faq-list />
      </b-tab> -->
      <!--Topic -->
      <!-- <b-tab>
        <template #title>
          <feather-icon icon="SettingsIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t("breadcrumb.topic_configuration")
          }}</span>
        </template>
        <configuration />
      </b-tab> -->
      <!-- <b-tab>
        <template #title>
          <feather-icon icon="MessageCircleIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t("breadcrumb.topic")
          }}</span>
        </template>
        <div id="topic-search"></div>
        <topic-list />
      </b-tab> -->
      <!-- <b-tab lazy>
        <template #title>
          <feather-icon
            icon="TrendingUpIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.frequently_topic')
          }}</span>
        </template>
        <div id="frequently-topic-search" />
        <frequently-topic-list />
      </b-tab> -->
      <b-tab lazy>
        <template #title>
          <feather-icon
            icon="LayersIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.summaryConversation')
          }}</span>
        </template>
        <div id="conversation-summary" />
        <conversation-summary-list :tab-index="tabIndex" />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon
            icon="UploadCloudIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.pushed_to_rag')
          }}</span>
        </template>
        <div id="pushed-to-rag" />
        <pushed-to-rag-list :tab-index="tabIndex" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BCard, BTab, BTabs, BCardText, BButton,
} from 'bootstrap-vue'
import QuestionList from './components/question/Index.vue'
import FaqList from './components/frequently-question/Index.vue'
import SearchInputs from './components/question/searchInput'
import TopicList from './components/topic/Index.vue'
import Configuration from './components/configuration/index.vue'
import PushedToRagList from './components/pushed-to-rag/Index.vue'
import ConversationSummaryList from './components/conversation-summary/Index.vue'

export default {
  components: {
    BCard,
    BCardText,
    BButton,
    BTab,
    BTabs,
    QuestionList,
    FaqList,
    TopicList,
    Configuration,
    PushedToRagList,
    ConversationSummaryList,
  },
  data() {
    return {
      data: {},
      loading: false,
      tabIndex: 0,
    }
  },
  created() {
    const tab = this.$route.query.tabIndex
    if ([0, 1].includes(parseInt(tab, 10))) {
      this.tabIndex = parseInt(tab, 10)
    }
  },
  mounted() {},
  methods: {},
  setup() {
    const searchFields = SearchInputs
    const permissionType = 'summary-conversation'
    return { permissionType, searchFields }
  },
}
</script>
